(function () {
    'use strict';

    angular
        .module('sodCommon')
        .directive('sodGrid', sodGrid);

    function sodGrid() {
        return {
            restrict: 'E',
            scope: {config: '='},
            templateUrl: 'common/components/sod-grid',
            controller: sodGridCtrl,
            controllerAs: 'vm',
            bindToController: true,
        };

        function sodGridCtrl($scope, lodash, GroupFilterFactory, SodGridFactory, FilterFactory) {
            var vm = this;

            this.$onInit = function() {
                // functions
                vm.handlePagination = handlePagination;
                
                vm.page = 1;
                vm.pages = 1;
                vm.pageSize = 15;
                vm.paginationSize = 5;
                vm.paginations = [];
                vm.rows = [];
                vm.count = vm.rows.length;
                vm.groupFilterFactory = GroupFilterFactory(vm.config);
                vm.sodGridInstance = SodGridFactory(vm.config);

                vm.selectJob = selectJob;

                init();
            }

            function selectJob(job_info) {
                window.dataLayer.push({
                    'event': 'jobListItemClick',
                    'job_link': job_info.ad_info.ad_link,
                    'entity_id': job_info.select_id,
                    'entity_label': job_info.job_title
                });
                vm.sodGridInstance.selectJob(lodash.get(vm, 'config.id'), job_info.id);
            }

            function handlePagination(page) {
                if (page === vm.page) return;

                vm.page = page;
                applyFilter();
            }

            function init() {
                var groupFilterFactoryApplyFilter = $scope.$on([vm.groupFilterFactory.eventPrefix, vm.config.id].join('.'), function (e, eventData) {
                    var rows = lodash.get(eventData, 'rows', []);
                    var count = lodash.get(eventData, 'count', 0);

                    // vm.rows = [lodash.set(lodash.head(rows), 'premium', true)].concat(rows.slice(1));
                    vm.rows = rows;
                    vm.count = count;
                    formPagination();
                });
                var groupFilterFactoryLoading = $scope.$on([vm.groupFilterFactory.eventPrefix, vm.config.id, vm.groupFilterFactory.eventLoading].join('.'), function (e, eventData) {
                    vm.isLoading = eventData;
                });
                var groupFilterFactoryPageReset = $scope.$on([vm.groupFilterFactory.eventPrefix, vm.config.id, vm.groupFilterFactory.eventPageChange].join('.'), function (e, eventData) {
                    vm.page = eventData;
                });

                $scope.$on('destroy', function () {
                    groupFilterFactoryApplyFilter();
                    groupFilterFactoryLoading();
                    groupFilterFactoryPageReset();
                });

                applyFilter();
            }

            function applyFilter() {
                var params = getParams();
                vm.groupFilterFactory.applyFilter(lodash.get(vm, 'config.id'), params);
            }

            function getParams() {
                return {
                    page: vm.page,
                    pageSize: vm.pageSize,
                    take: vm.pageSize,
                };
            }

            function formPagination() {
                var list = [];
                var pageLimit = vm.paginationSize;
                var total = Math.ceil(vm.count / vm.pageSize);
                var upperLimit, lowerLimit;
                var currentPage = lowerLimit = upperLimit = Math.min(vm.page, total);

                for (var b = 1; b < pageLimit && b < total;) {
                    if (lowerLimit > 1) {
                        lowerLimit--;
                        b++;
                    }
                    if (b < pageLimit && upperLimit < total) {
                        upperLimit++;
                        b++;
                    }
                }

                for (var i = lowerLimit; i <= upperLimit; i++) {
                    if (i == currentPage) {
                        list.push({pageNumber: i, isActive: true});
                    } else {
                        list.push({pageNumber: i});
                    }
                }

                vm.paginations = list;
            }
        }
    }
})();